import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { APIResponseWrapper } from '../models/common/api-response-wrapper';
import { APIListWrapper } from '../models/common/api-list-wrapper.model';
import {
  DriverPerformanceRow,
  FleetAnalyticsFilters,
  TruckProfitabilityDashboard,
  TruckProfitabilityFilters,
  VehicleAccountingProfile,
  VehicleProfitabilityRow
} from './fleet-analytics.model';

@Injectable({ providedIn: 'root' })
export class FleetAnalyticsService {
  constructor(private http: HttpClient) {}

  getDriverPerformance(filters: FleetAnalyticsFilters = {}): Observable<APIListWrapper<DriverPerformanceRow>> {
    return this.http.get<APIListWrapper<DriverPerformanceRow>>(
      `${environment.restApiUrl}fleet-performance/drivers`,
      { params: this.params(filters) }
    );
  }

  getVehicleProfitability(filters: FleetAnalyticsFilters = {}): Observable<APIListWrapper<VehicleProfitabilityRow>> {
    return this.http.get<APIListWrapper<VehicleProfitabilityRow>>(
      `${environment.restApiUrl}fleet-profitability/vehicles`,
      { params: this.params(filters) }
    );
  }

  getTruckDashboard(filters: TruckProfitabilityFilters): Observable<TruckProfitabilityDashboard> {
    let params = new HttpParams().set('vehicleId', filters.vehicleId.toString());
    for (const key of ['periodFrom', 'periodTo', 'basis']) {
      const value = (filters as unknown as Record<string, unknown>)[key];
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, value instanceof Date ? value.toISOString() : value.toString());
      }
    }
    return this.http.get<TruckProfitabilityDashboard>(
      `${environment.restApiUrl}fleet-profitability/truck-dashboard`,
      { params }
    );
  }

  getVehicleAccountingProfile(vehicleId: number): Observable<VehicleAccountingProfile | null> {
    return this.http.get<VehicleAccountingProfile | null>(
      `${environment.restApiUrl}fleet-profitability/vehicle-accounting-profiles/${vehicleId}`
    );
  }

  saveVehicleAccountingProfile(
    vehicleId: number,
    profile: VehicleAccountingProfile
  ): Observable<APIResponseWrapper<VehicleAccountingProfile>> {
    return this.http.put<APIResponseWrapper<VehicleAccountingProfile>>(
      `${environment.restApiUrl}fleet-profitability/vehicle-accounting-profiles/${vehicleId}`,
      profile
    );
  }

  private params(filters: FleetAnalyticsFilters): HttpParams {
    let params = new HttpParams();
    for (const key of ['periodFrom', 'periodTo', 'resourceSource', 'driverId', 'vehicleId', 'vehicleTypeId']) {
      const value = (filters as Record<string, unknown>)[key];
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, value instanceof Date ? value.toISOString() : value.toString());
      }
    }
    return params;
  }
}
